<template>
  <Layout header-class="header-left-align" nav-alignment="left">
    <BlogBanner :title="post.title" article />
    <div class="rn-blog-details-area" :class="{
      'background-bg-post1-light': userLogin === true,
      'background-bg-post1': userLogin === false
    }">
      <div class="post-page-banner rn-section-gapTop">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div class="content text-center">
                <div class="thumbnail alignwide">
                  <img class="w-100 radius" :src="post.imgdetail" alt="" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="blog-details-content pt--60 rn-section-gapBottom">
        <div class="container">
          <div class="row">
            <div class="col-lg-8 offset-lg-2">
              <div class="content">
                <ul class="rn-meta-list mb--30">
                  <li>
                    {{ post.publishedAt }}
                  </li>
                </ul>
                <p v-text="post.body" />

                <div v-if="post.categories && post.categories.length" class="category-meta blog-taxonomy">
                  <span class="text">{{ $t('Blog.categories_title') }}</span>
                  <div class="tagcloud">
                    <router-link
                      v-for="category in post.categories"
                      :key="category"
                      :to="`/category/${AppFunctions.slugify(category)}`"
                    >
                      {{ $t(`Blog.categories.${category}`) }}
                    </router-link>
                  </div>
                </div>
                <div v-if="post.tags && post.tags.length" class="category-meta blog-taxonomy">
                  <span class="text">{{ $t('Blog.tags_title') }}</span>
                  <div class="tagcloud">
                    <router-link
                      v-for="tag in post.tags"
                      :key="tag"
                      :to="`/tag/${AppFunctions.slugify(tag)}`"
                    >
                      {{ $t(`Blog.tags.${tag}`) }}
                    </router-link>
                  </div>
                </div>


              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>

<script>
import Layout from '../components/common/Layout'
import BlogBanner from '../components/blog/BlogBanner'
import BlogPostMixin from '../mixins/BlogPostMixin'

export default {
  name: 'BlogDetailsPage',
  components: { Layout, BlogBanner },
  mixins: [BlogPostMixin],
  computed: {
    post() {
      return this.posts.find((item) => item.id === this.$route.params.id) || {}
    },
    userLogin() {
      return this.$store.state.userLogin
    }
  }
}
</script>
<style scoped>
.background-bg-post1 {
  background-image: url(../assets/images/Newlandindpage/lightmode/bg-light-detail.png);
  background-size: cover;
  background-position: center;
  z-index: 10;
  width: 100%;
  min-height: 100vh;
}

.background-bg-post1-light {
  background-image: url(../assets/images/Newlandindpage/lightmode/bg-brandetail.png);
  background-size: cover;
  background-position: center;
  z-index: 10;
  width: 100%;
  min-height: 100vh;
}

/* Light mode overrides for details page */
.active-light-mode .rn-blog-details-area p,
.active-light-mode .rn-blog-details-area .category-meta .text {
  color: #181818;
}

.active-light-mode .rn-comment-form input,
.active-light-mode .rn-comment-form textarea {
  background-color: #f5f8fa;
  border-color: #d8d8d8;
  color: #181818;
}

.active-light-mode .rn-comment-form input:focus,
.active-light-mode .rn-comment-form textarea:focus {
  border-color: var(--color-primary);
}
</style>
